<div class="date-container">
  <eg-input
    class="ngx-daterangepicker-action"
    [value]="formattedValue"
    [label]="labelWithSuffix"
    [name]="name"
    [placeholder]="placeholder"
    [readonly]="true"
    [disabled]="disabled"
    (click)="openDatePicker($event)"
    (blurred)="markInputAsTouched()"
  >
    <img egFieldSuffixDirective src="/assets/icons/field_date.svg" class="date-icon ngx-daterangepicker-action" />
  </eg-input>

  <p-datepicker
    #dateTimePicker
    class="p-calendar date-time"
    [appendTo]="appendTo"
    [(ngModel)]="dateTime"
    [defaultDate]="defaultDate"
    inputId="dateTimeInput"
    [minDate]="minDateFormatted"
    [maxDate]="maxDateFormatted"
    [readonlyInput]="true"
    [placeholder]="placeholder"
    [showTime]="showTimePicker"
    [hourFormat]="'24'"
    [stepMinute]="timeInterval"
    (onSelect)="onInputChanged($event)"
    [hideOnDateTimeSelect]="false"
  >
  </p-datepicker>

  @if (control?.touched && control?.errors && errorMessage) {
    <eg-form-error [errorMessage]="errorMessage" class="input-error"></eg-form-error>
  }
</div>
